import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Requestable, RequestEventListener } from '@philips-emr/tws-core/lib/component/types';
import JWTToken from '@philips-emr/tws-core/lib/services/auth/JWTToken';
import { ToastProps } from '@philips-emr/tws-core/lib/services/toast-service';

export type LoginNotification = Pick<ToastProps, 'highlight' | 'level' | 'message' | 'title'>;

class LoginAPI extends ComponentAPI implements Requestable<JWTToken> {

  /** @event */
  @AwesomeEvent
  onSuccess = new RequestEventListener<JWTToken>();

  /** @event */
  @AwesomeEvent
  onCatch = new RequestEventListener<Error | Record<string, unknown>>();

  getApplicationName(): string {
    return this.state.applicationName;
  }

  setApplicationName(applicationName: string): void {
    this.setState({ applicationName });
  }

  getBottomBarExpression(): string {
    return this.state.bottomBarExpression;
  }

  setBottomBarExpression(bottomBarExpression: string): void {
    this.setState({ bottomBarExpression });
  }

  getForgotPasswordExpression(): string {
    return this.state.forgotPasswordExpression;
  }

  setForgotPasswordExpression(forgotPasswordExpression: string): void {
    this.setState({ forgotPasswordExpression });
  }

  getHideBottomBar(): boolean {
    return this.state.hideBottomBar;
  }

  setHideBottomBar(hideBottomBar: boolean): void {
    this.setState({ hideBottomBar });
  }

  getLoginExpression(): string {
    return this.state.loginExpression;
  }

  setLoginExpression(loginExpression: string): void {
    this.setState({ loginExpression });
  }

  getLogo(): string {
    return this.state.logo;
  }

  setLogo(logo: string): void {
    this.setState({ logo });
  }

  getNotification(): LoginNotification {
    return this.state.notification;
  }

  setNotification(notification: LoginNotification): void {
    return this.setState({ notification });
  }

  removeNotification(): void {
    return this.setState({ notification: null });
  }

  getPasswordExpression(): string {
    return this.state.passwordExpression;
  }

  setPasswordExpression(passwordExpression: string): void {
    this.setState({ passwordExpression });
  }

  getUsernameExpression(): string {
    return this.state.usernameExpression;
  }

  setUsernameExpression(usernameExpression: string): void {
    this.setState({ usernameExpression });
  }

  getVersionExpression(): string {
    return this.state.versionExpression;
  }

  setVersionExpression(versionExpression: string): void {
    this.setState({ versionExpression });
  }
}

export default LoginAPI;
